import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import transferForms from './transferForms';

import FormWrapper from '../../../common/components/FormWrapper';
import { AppDispatch } from '../../../store';
import settingsSelectors from '../../../settings/settingsSelector';
import { loadAdvisors } from '../../../settings/settingsReducer';
import type { Transfer } from '../../../common/types/transfer';

type Props = {
  transfer: Transfer;
  updateTransfer: (client: Transfer) => void;
  saveTransfer?: (client: Transfer) => void;
};

function TransferForm({ transfer, updateTransfer, saveTransfer }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const advisors = useSelector(settingsSelectors.getAdvisors);

  React.useEffect(() => {
    dispatch(loadAdvisors());
  }, []);

  return (
    <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
      <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
        {transferForms(advisors).map((form) => (
          <FormWrapper key={form.key} form={form} item={transfer} save={saveTransfer} update={updateTransfer} />
        ))}
      </Box>
    </Stack>
  );
}

export default TransferForm;
